export function page(ctx) {
    return {
        styles: {
            main: { bg_color: ctx.SCR, bg_opa: 255, border_width: 0, border_color: ctx.BORDER },
        },
    };
}
